import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function FavoriteButton({ productId, className = "" }) {
  const { customer } = useCustomerAuth();
  const nav = useNavigate();
  const [fav, setFav] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (customer && productId) {
      api.get("/shop/favorites").then((r) => setFav((r.data.ids || []).includes(productId))).catch(() => {});
    } else {
      setFav(false);
    }
  }, [customer, productId]);

  const toggle = async (e) => {
    e?.preventDefault?.(); e?.stopPropagation?.();
    if (!customer) { toast.info("Connectez-vous pour ajouter aux favoris"); nav("/compte"); return; }
    setBusy(true);
    try {
      if (fav) { await api.delete(`/shop/favorites/${productId}`); setFav(false); }
      else { await api.post(`/shop/favorites/${productId}`); setFav(true); toast.success("Ajouté à vos favoris"); }
    } catch { toast.error("Erreur"); } finally { setBusy(false); }
  };

  return (
    <button onClick={toggle} disabled={busy} aria-label="Favori" data-testid={`fav-btn-${productId}`}
      className={`flex items-center justify-center rounded-full transition-colors ${fav ? "text-red-500" : "text-stone hover:text-red-500"} ${className}`}>
      <Heart size={20} className={fav ? "fill-red-500" : ""} />
    </button>
  );
}
